import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import SignOutDialog from '@components-clean/legacy/sign-out/sign-out';
import styles from '@components-clean/page-nav/page-nav-footer/style.module.scss';
import { useReadOnlyContext } from '@contexts-clean/read-only-context';
import LocalStorage from '@utils-clean/local-storage-service';
import { PopupService } from '@utils-clean/popup-service';
import { useAuthorization, useBoolean, useTranslation } from '@hooks/index';
import '@styles/kendo-theme-opra-legacy/legacy-navbar-overwrite.scss';

export const PageNavErrorSignout = () => {
    const { t } = useTranslation();
    const openSignOut = useBoolean(false);
    const user = useAuthorization();
    const { readOnly } = useReadOnlyContext();

    const openDialog = () => {
        if (readOnly) return;
        PopupService.closePopups();
        openSignOut.setTrue();
    };

    return (
        <>
            <SignOutDialog
                open={openSignOut.value}
                onClose={() => {
                    // TODO, remove following LocalStorage line, after testing
                    LocalStorage.removeItem(user!, 'ForceNavError');
                    openSignOut.setFalse();
                }}
            />
            <div className={cn(styles.pageNavFooter, 'k-px-7 k-pt-2.5 k-pb-3')}>
                <div className="k-d-flex k-w-full k-grid-cols-1">
                    <button
                        type="button"
                        data-testid="sign-out-button"
                        className={cn(
                            styles.buttonLeftBorder,
                            'k-w-full k-bg-transparent k-border-0 k-cursor-pointer k-outline-none k-text-left',
                            'k-p-0 k-d-flex k-align-items-center k-justify-content-between',
                        )}
                        onClick={openDialog}
                    >
                        {t('common:signOut')}
                        <FontAwesomeIcon
                            data-testid="sign-out-icon"
                            className="k-ml-2"
                            style={{ width: 18, height: 18 }}
                            icon={['far', 'power-off']}
                        />
                    </button>
                </div>
            </div>
        </>
    );
};
